import React from "react";
import AxiosConfig from "axiosConfig";
import "containers/Account/Info/Account.css";
import ProfileForm from "components/Account/Profile/ProfileForm";
import * as ProfileHelper from "components/Account/Profile/ProfileHelper";
import RoundedButton from "components/General/Form/CustomButton/RoundedButton";

/**
 * @description Creates the My Account page for the user
 * @class Account
 * @implements BrowserRouter as Router
 * @extends React.Component
 * @type {Account}
 * @example <Account />
 * pre-condition: all the imports
 * post-condition: returns the Account page
 * @param null
 * @returns {Account}
 */

class Account extends React.Component {
  /**
   * coverPic is what is displayed or uploaded by the user.
   * If changed it is sent to back end as cover_pic.
   * profilePic is displayed on page or uploaded by user.
   * It is sent to back end as profile_pic.
   * @type {{profileVisibility: string, errorMap: Map<any, any>,
   * address: string, gender: string, hasChildren: string,
   * profilePic: string, mobile: string, fullName: string, cause: string,
   * favoriteThing: string, schoolGrade: string, aboutMe: string,
   * heroes: string, dream: string, school: string,
   * canEditVisibility: boolean,
   * childrenProfileVisibility: string, dob: string, coverPic: string,
   * superPowers: string, userType: string,
   * projectInterest: [], email: string}}
   */
  state = {
    email: "",
    fullName: "",
    mobile: "",
    address: "",
    profilePic: "",
    coverPic: "",
    dob: "",
    formatted_dob: "",
    gender: "",
    hasChildren: "",
    aboutMe: "",
    favoriteThing: "",
    dream: "",
    heroes: "",
    superPowers: "",
    school: "",
    schoolGrade: "",
    cause: "",
    projectInterest: [],
    canEditVisibility: true,
    userType: "",
    profileVisibility: "",
    childrenProfileVisibility: "",
    is_above_eighteen: false,
    errorMap: new Map(),
    user_type: "",
    coverPicError: "",
    profilePicError: "",
  };
  componentDidMount() {
    this.fetchProfileDetails(this);
    this.fetchHasChildren(this);
  }
  fetchProfileDetails(obj) {
    AxiosConfig.get("profile/details/")
      .then((res) => {
        this.setState({
          email: res.data.email,
          fullName: res.data.full_name,
          mobile: res.data.mobile,
          address: res.data.address,
          profilePic: res.data.profile_pic,
          coverPic: res.data.cover_pic,
          heroes: res.data.heroes,
          dob: res.data.dob,
          formatted_dob: res.data.formatted_dob,
          gender: res.data.gender,
          aboutMe: res.data.about_me,
          favoriteThing: res.data.favorite_thing,
          dream: res.data.dream,
          superPowers: res.data.super_powers,
          cause: res.data.cause,
          projectInterest: res.data.project_interest,
          profileVisibility: res.data.visibility,
          childrenProfileVisibility:
            res.data.child_profile_visibility === null
              ? ""
              : res.data.child_profile_visibility,
          is_above_eighteen: res.data.is_above_eighteen,
          user_type: res.data.user_type,
        });
        // Setting user type [child or adult] based on response from backend
        if ("user_type" in res.data) {
          if (res.data.user_type === "child") {
            this.setState({
              userType: res.data.user_type,
              school: res.data.school,
              schoolGrade: res.data.school_grade,
              canEditVisibility: false,
            });
          } else {
            this.setState({ userType: "adult" });
          }
        } else {
          this.setState({ userType: "adult" });
        }
      })
      .catch();
  }

  fetchHasChildren(obj) {
    AxiosConfig.get("profile/has_children/").then(function (response) {
      obj.setHasChildren(response);
    });
  }

  setHasChildren(response) {
    this.setState((prevState) => ({
      hasChildren: response.data["has_children"],
    }));
  }

  validate() {
    this.setState({ pageError: "" });
    ProfileHelper.validateFullName.bind(this)();
    this.state.is_above_eighteen
      ? ProfileHelper.validateUserBirthDate.bind(this)()
      : this.state.user_type === "child"
      ? ProfileHelper.validateChildBirthDate.bind(this)()
      : ProfileHelper.validateTeenBirthDate.bind(this)();
    ProfileHelper.validateMobileNumber.bind(this)();
  }

  onSaveClicked(event) {
    this.validate();
    if (this.state.errorMap.size !== 0) {
      this.setState({ pageError: "Resolve the errors to continue" });
    } else {
      let formData = this.baseFormData();
      AxiosConfig.put("profile/details/", formData, {
        headers: {
          "content-type": "multipart/form-data",
        },
      })
        .then(function (res) {
          let userList = JSON.parse(sessionStorage.getItem("userList"));
          userList.map((elem)=>{
            if(res.data.email===elem.email){
              elem.full_name = res.data.full_name
            }
          })
          sessionStorage.setItem("userList", JSON.stringify(userList));
           window.location.reload();
        })
        .catch();
    }
  }
  baseFormData() {
    let formData = new FormData();
    if (this.state.finalImage)
      formData.append(
        "profile_pic",
        this.state.finalImage,
        this.state.finalImage.name
      );
    if (this.state.finalCoverImage)
      formData.append(
        "cover_pic",
        this.state.finalCoverImage,
        this.state.finalCoverImage.name
      );
    formData.append("full_name", this.state.fullName);
    formData.append("address", this.state.address);
    formData.append("mobile", this.state.mobile);
    // formData.append("dob", this.state.dob);
    formData.append("gender", this.state.gender);
    formData.append("about_me", this.state.aboutMe);
    formData.append("favorite_thing", this.state.favoriteThing);
    formData.append("dream", this.state.dream);
    formData.append("heroes", this.state.heroes);
    formData.append("super_powers", this.state.superPowers);
    formData.append("cause", this.state.cause);
    formData.append("school", this.state.school);
    formData.append("school_grade", this.state.schoolGrade);
    formData.append("visibility", this.state.profileVisibility);
    this.state.projectInterest.forEach((item) => {
      formData.append("project_interest", item);
    });
    formData.append(
      "child_profile_visibility",
      this.state.childrenProfileVisibility
    );
    return formData;
  }
  render() {
    return (
      <div className="mb-15 my-account">
        <ProfileForm
          onboarding={false}
          email={this.state.email}
          fullName={this.state.fullName}
          address={this.state.address}
          mobile={this.state.mobile}
          dob={this.state.dob}
          formatted_dob={this.state.formatted_dob}
          gender={this.state.gender}
          aboutMe={this.state.aboutMe}
          favoriteThing={this.state.favoriteThing}
          dream={this.state.dream}
          superPowers={this.state.superPowers}
          heroes={this.state.heroes}
          profilePic={this.state.profilePic}
          coverPic={this.state.coverPic}
          school={this.state.school}
          schoolGrade={this.state.schoolGrade}
          cause={this.state.cause}
          projectInterest={this.state.projectInterest}
          userType={this.state.userType}
          errorMap={this.state.errorMap}
          onDataChange={ProfileHelper.onDataChange.bind(this)}
          onImageChange={ProfileHelper.onImageChange.bind(this)}
          onCoverImageChange={ProfileHelper.onCoverImageChange.bind(this)}
          onSaveClicked={this.onSaveClicked.bind(this)}
          onProjectInterestDataChange={ProfileHelper.onProjectInterestDataChange.bind(
            this
          )}
          canEditVisibility={this.state.canEditVisibility}
          profileVisibility={this.state.profileVisibility.toUpperCase()}
          childrenProfileVisibility={this.state.childrenProfileVisibility ? this.state.childrenProfileVisibility.toUpperCase() : this.state.childrenProfileVisibility}
          hasChildren={this.state.hasChildren}
          isMyAccount={true}
          coverPicError={this.state.coverPicError}
          profilePicError={this.state.profilePicError}
        />
        {this.state.pageError ? (
          <div className="text_red">{this.state.pageError}</div>
        ) : (
          ""
        )}
        {/* form ends here */}
        <div className="mb-15 onboarding_button_options">
          <RoundedButton
            title="&nbsp;&nbsp;&nbsp;Save&nbsp;&nbsp;&nbsp;"
            buttonClassName="background_dark_orange"
            textThemeClassName="text_medium text_white"
            handleOnClick={this.onSaveClicked.bind(this)}
            borderRadius="6px"
          />
        </div>
      </div>
    );
  }
}

export default Account;
